module.exports = __webpack_public_path__ + "img/dake_null.a0e5c63c.png";